export default __webpack_public_path__ + "static/media/신협.1f4e91e2.svg";